/**
 * Created by Rodrigo Quesada on 30/04/17.
 */
import {NgModule} from '@angular/core';
import {IsAfterValidatorDirective} from './is-after-validator.directive';

@NgModule({
    declarations: [IsAfterValidatorDirective],
    exports: [IsAfterValidatorDirective],
})
export class IsAfterValidatorModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/date/is-after-validator.module.ts